import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const Polaroid = ({ style })=>{
    return /*#__PURE__*/ _jsx("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: style.fontSize,
            height: style.fontSize
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: style.fontSize,
            height: style.fontSize,
            viewBox: "0 0 16 16",
            children: [
                /*#__PURE__*/ _jsx("title", {
                    children: "polaroid-photo"
                }),
                /*#__PURE__*/ _jsxs("g", {
                    strokeWidth: "1",
                    fill: "#ffffff",
                    stroke: "#ffffff",
                    children: [
                        /*#__PURE__*/ _jsx("rect", {
                            x: "0.5",
                            y: "0.5",
                            fill: "none",
                            stroke: "#ffffff",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: "10",
                            width: "15",
                            height: "15"
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("rect", {
                            x: "2.5",
                            y: "2.5",
                            fill: "none",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: "10",
                            width: "11",
                            height: "8",
                            "data-color": "color-2"
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("polyline", {
                            fill: "none",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: "10",
                            points: "4.5,10.5 9.5,5.5 13.5,8.5 ",
                            "data-color": "color-2"
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("circle", {
                            cx: "5",
                            cy: "5",
                            r: "1",
                            "data-color": "color-2",
                            "data-stroke": "none",
                            stroke: "none"
                        })
                    ]
                })
            ]
        })
    });
};
export default Polaroid;
